
sap["ls"]["preload"]["UCF_LoadingAnimation"] = function() {/* global _assert */
/// <reference path="../../core/debug/Tracer.js"/>
/* global UCF_DomUtil */
/// <reference path="../../core/util/DomUtil.js"/>
/* global UCF_JsUtil */
/// <reference path="../../core/util/JsUtil.js"/>
/* global UCF_StringUtil */
/// <reference path="../../core/util/StringUtil.js"/>
/* global UCF_BrowserEvent */
/// <reference path="../browser/BrowserEvent.js"/>
/* global UCF_LS */
/// <reference path="../core/LS.js"/>
/* global UCF_System */
/// <reference path="../core/System.js"/>
/* global UCF_LayeredControl */
/// <reference path="./base/LayeredControl.js"/>
/* global UCF_AriaStateHelper */
/// <reference path="../../core/util/AriaStateHelper.js"/>

/**
 * 
 * @version
 *
 * @class
 * @param {HTMLElement} oDomRef
 * @param {UCF_LS} oLS
 */
function UCF_LoadingAnimation(oDomRef, oLS) {if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["UCF_LoadingAnimation"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(oDomRef) === "object", "typeof(oDomRef) === \"object\"", "LoadingAnimation.js(29): UCF_LoadingAnimation"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oDomRef != null, "oDomRef != null", "LoadingAnimation.js(30): UCF_LoadingAnimation"); };
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oLS instanceof UCF_LS, "oLS instanceof UCF_LS", "LoadingAnimation.js(31): UCF_LoadingAnimation"); };

	UCF_LayeredControl["apply"](this, [oDomRef, oLS]);

	this["attachLSEvent"](this["oLS"]["E_EVENTS"]["ControlVisibilityChange"], "onFooterToolbarVisibilityChange");

	this["iAlignment"] = UCF_LayeredControl["ALIGNMENT"]["BROWSERCENTER"];
	this["sTimer"] = null;
	this["sType"] = !UCF_DomUtil["$"]("ur-loading-footer") ? this["TYPE"]["INDICATOR"] : this["TYPE"]["DIALOG"];
};window["UCF_LoadingAnimation"] = UCF_LoadingAnimation; ;if (__UCF_COVERAGE__) { window.UCF_classes.push("UCF_LoadingAnimation"); UCF_LoadingAnimation["_"] = {UCF_LoadingAnimation: 0}; }; ;
UCF_LoadingAnimation["prototype"] = new (UCF_ClassLoader["oGetClass"]("UCF_LayeredControl"))(); UCF_LoadingAnimation.prototype["sClassName"] = "UCF_LoadingAnimation";

UCF_LoadingAnimation["prototype"]["TYPE"] = {
	"INDICATOR": "INDICATOR",
	"DIALOG": "DIALOG"
};

/**
 * Triggers the loading animation with given delay in ms
 * @public
 */
UCF_LoadingAnimation["prototype"]["trigger"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["trigger"]++; }; 

	if (this["sTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["sTimer"]);
	}
	this["sTimer"] = UCF_JsUtil["delayedCall"](this["iDelay"], this, "show");

};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["trigger"] = 0; };

/**
 * Shows the loading animation immediately
 * @public
 */
UCF_LoadingAnimation["prototype"]["show"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["show"]++; }; 

	if (this["sTimer"]) {
		UCF_JsUtil["clearDelayedCall"](this["sTimer"]);
	}
	this["open"]();
	this["fireShow"]();
	if (window["UCF_System"]["bIs508"]) {
		//lsaccessibility handler won't be accessed because focusin event triggering lsaccessibility will be canceled in Browserwindow during LS lock state
		//therefore manually set the title attribute

		if (!this["oDomRef"]["getAttribute"]("title") && !this["oDomRef"]["title"]) {
			UCF_DomUtil["setTooltip"](this["oDomRef"], this["oLS"]["sGetText"]("SAPUR_LOADINGANIM"));
		}
		UCF_DomUtil["setTabIndex"](this["oDomRef"], 0);
		if (this["oLS"]["oBrowserWindow"]["bIsFocussed"]()) UCF_DomUtil["moveFocusDomElement"](this["oDomRef"]);
		//BCP 278200 / 2016: In a scenario with two browser windows communication with EPCM eventing the moveFocus can cause that the application in the background becomes visible once 508 is enabled and the loading animation appears.
	}
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setRole"](this["oDomRef"], 'alert');
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["show"] = 0; };

/**
 * Cancels the loading animation, hides if already shown and
 * stops the timeout if canceled before
 * @public
 */
UCF_LoadingAnimation["prototype"]["cancel"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["cancel"]++; }; 

	UCF_JsUtil["clearDelayedCall"](this["sTimer"]);
	this["sTimer"] = null;
	if (window["UCF_System"]["bIs508"]) {
		UCF_DomUtil["resetTabIndex"](this["oDomRef"]);
	}
	if (window["UCF_System"]["bIsAria"]) {
		UCF_AriaStateHelper["setRole"](this["oDomRef"]);
	}
	this["close"]();
	this["fireHide"]();
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["cancel"] = 0; };

/**
 * Sets the text of the loading animation
 *
 * @public
 * @param {string} sText the new text of the textview
 */
UCF_LoadingAnimation["prototype"]["setText"] = function(sText) {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["setText"]++; }; 

	if (__UCF_ASSERT__) { UCF_Tracer.assert(typeof(sText) === "string", "typeof(sText) === \"string\"", "LoadingAnimation.js(115): setText"); };

	var sClassName = "";
	var bShowFooterToolbar = false;
	var oFooterRef = UCF_DomUtil["$"]("ur-loading-footer");
	var bFullPageLockStateEnabled = this["oLS"]["oGetRenderManager"]()["getRenderer"]('FeatureFlags')["renderIsEnabled"]({
		"Feature": 'oneux.fullpagelockstate'
	}, this["oLS"]["oGetRenderManager"]());

	if (oFooterRef) {
		var oUCFFooterToolbar = this["oGetControlByDomRef"](UCF_DomUtil["oGetFirstChild"](oFooterRef), false);
		if (oUCFFooterToolbar) bShowFooterToolbar = oUCFFooterToolbar["sVisibility"] === "VISIBLE";
	}
	var oTextDiv = UCF_DomUtil["$"]("loadinganimationtext");
	if (!sText && !oTextDiv) return;

	if (!sText) {
		this["oDomRef"]["childNodes"][1]["removeChild"](oTextDiv);
		this["sText"] = sText;
		this["setClientProperty"]("Text", sText, true);
		if (bFullPageLockStateEnabled) {
			if (this["sType"] === this["TYPE"]["INDICATOR"]) {
				sClassName = "urLoadA lsLoadABlockLayer";
			} else {
				sClassName = "urLoadA lsLoadABlockLayer lsLoadADialogBoxPad";
				if (bShowFooterToolbar) sClassName += " lsLoadADialogBox lsLoadABox sapContrast";
			}
		} else {
			if (this["sType"] === this["TYPE"]["INDICATOR"]) {
				sClassName = "urLoadA";
			} else {
				sClassName = "urLoadA lsLoadADialogBoxPad";
				if (bShowFooterToolbar) sClassName += " lsLoadADialogBox lsLoadABox_WOBL sapContrast";
			}
		}
		UCF_DomUtil["setClass"](UCF_DomUtil["$"]("ur-loading-box"), sClassName);
		return;
	}
	if (!oTextDiv) {
		oTextDiv = document["createElement"]("DIV");
		oTextDiv["setAttribute"]("id", "loadinganimationtext");
		UCF_DomUtil["setClass"](oTextDiv, "urLoadATxt lsLoadATxtPadding");
		if (this["sType"] === this["TYPE"]["INDICATOR"]) {
			UCF_DomUtil["$"]("ur-loading-box")["appendChild"](oTextDiv);
		} else {
			UCF_DomUtil["$"]("ur-loading-box")["insertBefore"](oTextDiv, UCF_DomUtil["$"]("ur-loading-footer"));
		}
	}
	if (bFullPageLockStateEnabled) {
		if (this["sType"] === this["TYPE"]["INDICATOR"]) {
			sClassName = "urLoadA lsLoadABlockLayer lsLoadABox sapContrast";
		} else {
			sClassName = "urLoadA lsLoadABlockLayer lsLoadADialogBoxPad lsLoadABox sapContrast";
			if (bShowFooterToolbar) sClassName += " lsLoadADialogBox";
		}
	} else {
		if (this["sType"] === this["TYPE"]["INDICATOR"]) {
			sClassName = "urLoadA lsLoadABox_WOBL sapContrast";
		} else {
			sClassName = "urLoadA lsLoadADialogBoxPad lsLoadABox_WOBL sapContrast";
			if (bShowFooterToolbar) sClassName += " lsLoadADialogBox";
		}
	}
	UCF_DomUtil["setClass"](UCF_DomUtil["$"]("ur-loading-box"), sClassName);
	UCF_DomUtil["setInnerText"](oTextDiv, sText);

	this["sText"] = sText;
	this["setClientProperty"]("Text", sText, true);

};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["setText"] = 0; };

/**
 * Returns the value of the loading animation
 *
 * @return text of the loading animation
 * @type string
 *
 * @public
 */
UCF_LoadingAnimation["prototype"]["getText"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["getText"]++; }; 
	return this["sText"];
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["getText"] = 0; };

/**
 * Shows the aggregated FooterToolbar
 *
 * @public
 */
UCF_LoadingAnimation["prototype"]["showFooterToolbar"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["showFooterToolbar"]++; }; 

	var bFullPageLockStateEnabled = this["oLS"]["oGetRenderManager"]()["getRenderer"]('FeatureFlags')["renderIsEnabled"]({
		"Feature": 'oneux.fullpagelockstate'
	}, this["oLS"]["oGetRenderManager"]());

	var oFooterRef = UCF_DomUtil["$"]("ur-loading-footer");
	if (oFooterRef) {
		var oBoxRef = UCF_DomUtil["$"]("ur-loading-box");
		if (!UCF_DomUtil["bHasClass"](oBoxRef, "lsLoadADialogBox")) UCF_DomUtil["addClass"](oBoxRef, "lsLoadADialogBox");
		if (bFullPageLockStateEnabled) {
			if (!UCF_DomUtil["bHasClass"](oBoxRef, "lsLoadABox")) UCF_DomUtil["addClass"](oBoxRef, "lsLoadABox");
		} else {
			if (!UCF_DomUtil["bHasClass"](oBoxRef, "lsLoadABox_WOBL")) UCF_DomUtil["addClass"](oBoxRef, "lsLoadABox_WOBL");
		}
		if (!UCF_DomUtil["bHasClass"](oBoxRef, "sapContrast")) UCF_DomUtil["addClass"](oBoxRef, "sapContrast");

		oFooterRef["style"]["visibility"] = "visible";
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["showFooterToolbar"] = 0; };

/**
 * Hides the aggregated FooterToolbar
 *
 * @public
 */
UCF_LoadingAnimation["prototype"]["hideFooterToolbar"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["hideFooterToolbar"]++; }; 

	var bFullPageLockStateEnabled = this["oLS"]["oGetRenderManager"]()["getRenderer"]('FeatureFlags')["renderIsEnabled"]({
		"Feature": 'oneux.fullpagelockstate'
	}, this["oLS"]["oGetRenderManager"]());

	var oFooterRef = UCF_DomUtil["$"]("ur-loading-footer");
	if (oFooterRef) {
		var oBoxRef = UCF_DomUtil["$"]("ur-loading-box");
		if (UCF_DomUtil["bHasClass"](oBoxRef, "lsLoadADialogBox")) UCF_DomUtil["removeClass"](oBoxRef, "lsLoadADialogBox");
		if (bFullPageLockStateEnabled) {
			if (!this["sText"] && UCF_DomUtil["bHasClass"](oBoxRef, "lsLoadABox")) UCF_DomUtil["removeClass"](oBoxRef, "lsLoadABox");
		} else {
			if (!this["sText"] && UCF_DomUtil["bHasClass"](oBoxRef, "lsLoadABox_WOBL")) UCF_DomUtil["removeClass"](oBoxRef, "lsLoadABox_WOBL");
		}
		if (!this["sText"] && UCF_DomUtil["bHasClass"](oBoxRef, "sapContrast")) UCF_DomUtil["removeClass"](oBoxRef, "sapContrast");

		oFooterRef["style"]["visibility"] = "hidden";
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["hideFooterToolbar"] = 0; };

/**
 * Cancels the loading animation timeout
 * @private
 */
UCF_LoadingAnimation["prototype"]["destroy"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["destroy"]++; }; 

	this["cancel"](); //close explicitly the loading animation as there are case in which the loadingAnimation remains visible

	this["detachLSEvent"](this["oLS"]["E_EVENTS"]["ControlVisibilityChange"]);

	this["iAlignment"] = 0;
	this["sTimer"] = null;
	this["sType"] = "";
	this["sText"] = "";

	UCF_LayeredControl.prototype["destroy"]["apply"](this, arguments);

};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["destroy"] = 0; };

UCF_LoadingAnimation["prototype"]["onlsfocus"] = function (oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["onlsfocus"]++; }; 
	if (oBrowserEvent["oGetSource"]()["getAttribute"]("tp") === "START") {
		if (!this["focusLastChildControl"]() && oBrowserEvent["oFromElement"]) {
			UCF_DomUtil["focusDomElement"](oBrowserEvent["oFromElement"]);
		}
	}
	if (oBrowserEvent["oGetSource"]()["getAttribute"]("tp") === "END") {
		if (!this["focusFirstChildControl"]() && oBrowserEvent["oFromElement"]) {
			UCF_DomUtil["focusDomElement"](oBrowserEvent["oFromElement"]);
		}
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["onlsfocus"] = 0; };

/**
 * Handles the onlsaccessibility event that is called if the a source element within the
 * control gets the focus.
 * @private
 *
 * @param {UCF_BrowserEvent} oBrowserEvent the browser event object that occurred
 * @private
 */
UCF_LoadingAnimation["prototype"]["onlsaccessibility"] = function(oBrowserEvent) {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["onlsaccessibility"]++; }; 
	if (__UCF_ASSERT__) { UCF_Tracer.assert(oBrowserEvent instanceof UCF_BrowserEvent, "oBrowserEvent instanceof UCF_BrowserEvent", "LoadingAnimation.js(291): onlsaccessibility"); };

	if (oBrowserEvent["oGetSourceControl"]() !== this) return;

	var oAccessibilityHelper = oBrowserEvent["oAccessibilityHelper"];
	oAccessibilityHelper["setText"](this["oLS"]["sGetText"]("SAPUR_LOADINGANIM"));

};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["onlsaccessibility"] = 0; };

UCF_LoadingAnimation["prototype"]["onFooterToolbarVisibilityChange"] = function(oEvent) {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["onFooterToolbarVisibilityChange"]++; }; 
	var oFooterRef = UCF_DomUtil["$"]("ur-loading-footer");
	if (!oFooterRef) return;
	var oUCFFooterToolbar = this["oGetControlByDomRef"](UCF_DomUtil["oGetFirstChild"](oFooterRef), false);
	if (!oUCFFooterToolbar) return;
	if (oEvent["mParameters"]["sId"] !== oUCFFooterToolbar["sId"]) return;

	switch (oEvent["mParameters"]["sVisibility"]) {
		case "VISIBLE":
			this["showFooterToolbar"]();
			break;
		case "BLANK":
			this["hideFooterToolbar"]();
			break;
		case "NONE":
			this["hideFooterToolbar"]();
			break;
		case "ON_DEMAND":
			break;
		default:
			break;
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["onFooterToolbarVisibilityChange"] = 0; };
/**
 * Array of names of transported names/attributes (clientaccess defined).
 * @private
 * @type {string[]}
 */
UCF_LoadingAnimation["prototype"]["aAttributeNames"] = ["sText","iDelay","sCustomData"];

/**
 * Array of names of transported events.
 * @private
 * @type {string[]}
 */
UCF_LoadingAnimation["prototype"]["aEventNames"] = ["Show","Hide"];

/**
 * Array of names of public methods.
 * @private
 * @type {string[]}
 */
UCF_LoadingAnimation["prototype"]["aMethodNames"] = ["trigger","show","cancel","setText","getText","updateEvent","addClientListener","removeClientListener","playAnimation","getCustomData","sGetCustomData","show","hide","focus","oGetParentControl"];

/**
 * @private
 * @type {string}
 */
UCF_LoadingAnimation["prototype"]["sText"] = '';

/**
 * @private
 * @type {number}
 */
UCF_LoadingAnimation["prototype"]["iDelay"] = 2000;

/**
 * @private
 * @type {string}
 */
UCF_LoadingAnimation["prototype"]["sCustomData"] = '';

//#JSCOVER_EXCL_START
/** @protected */
UCF_LoadingAnimation["prototype"]["setDefaultValues"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["setDefaultValues"]++; }; 
	this["sText"] = '';
	this["iDelay"] = 2000;
	this["sCustomData"] = '';

	if (this["getClientControl"]() && !this["bKeepAlive"]) {
		this["setClientProperty"]("Text", '', true);
		this["setClientProperty"]("Delay", 2000, true);
		this["setClientProperty"]("CustomData", '', true);
	}
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["setDefaultValues"] = 0; };
//#JSCOVER_EXCL_STOP


/**
 * @protected
 * 
 * @fires LoadingAnimation::Show
 */
UCF_LoadingAnimation["prototype"]["fireShow"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["fireShow"]++; }; 
	/** @type {{}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 0, "arguments.length == 0", "LoadingAnimation.js(387): fireShow"); };
	
	mParams = {
		
	};
	
	this["fireSemanticEvent"]("LoadingAnimation", "Show", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["fireShow"] = 0; };

/**
 * @protected
 * 
 * @fires LoadingAnimation::Hide
 */
UCF_LoadingAnimation["prototype"]["fireHide"] = function() {;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["fireHide"]++; }; 
	/** @type {{}} */
	var mParams;

	if (__UCF_ASSERT__) { UCF_Tracer.assert(arguments["length"] == 0, "arguments.length == 0", "LoadingAnimation.js(405): fireHide"); };
	
	mParams = {
		
	};
	
	this["fireSemanticEvent"]("LoadingAnimation", "Hide", mParams, false, false, false);
};;if (__UCF_COVERAGE__) { UCF_LoadingAnimation["_"]["fireHide"] = 0; };

UCF_LoadingAnimation.prototype["aPublicMethods"] = ["trigger","show","cancel","setText","getText","showFooterToolbar","hideFooterToolbar"].concat(UCF_LoadingAnimation.prototype.aPublicMethods || []);
};